module.exports = __webpack_public_path__ + "img/sms-verification.ef9a0975.svg";